import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorLabel from '../../components/ErrorLabel/ErrorLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Alert from "../../components/Alert/Alert";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import axios from 'axios';
import css from '../Login/Login.module.scss'; // n.b. we're reusing Login styles
import { EMAIL_REGEX } from '../../constants';


/**
 * @class
 */
const PasswordRecover = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    _isMounted = false;

    // ---------- state: ----------
    state = {
        shouldShowAlert: false,
        alertMessage: 'The email you entered did not match any of our records'
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.source.cancel();
    }

    render() {
        return (
            <div className="App App--Login">
                <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage}</Alert>
                <div className={css.Login}>
                    <img className={css.Login__Logo} src="/assets/logo-V3.png" alt="V3 logo" />
                    <h3 className="text-white mt-5 pt-4">Password Recovery</h3>
                    <p className="mt-3">
                        Enter the email address used to sign in and you will receive instructions to reset your password.
                    </p>
                    <Formik
                        initialValues={{
                            email: '',
                        }}

                        validate={
                            (values)=> {
                                const errors = {};

                                if (!values.email.trim()) {
                                    errors.email = 'Please Enter An Email Address';
                                } else if (!EMAIL_REGEX.test(values.email)) {
                                    errors.email = 'Invalid Email Address';
                                }

                                return errors;
                            }
                        }

                        onSubmit={
                            (values) => {

                                axios.post(
                                    '/auth/reset',
                                    {email: values.email},
                                    {
                                        cancelToken: this.source.token
                                    })
                                    .then((res) => {
                                        // show success alert:
                                        this.setState({
                                            shouldShowAlert: true,
                                            alertMessage: 'An email has been sent to your V3 email address'
                                        });
                                        setTimeout(() => {
                                            // condition to guard against setting state when component is unmounted:
                                            if (this._isMounted) {
                                                this.setState({shouldShowAlert: false});
                                            }
                                        }, 5500);
                                    })
                                    .catch(err => {
                                        // show error alert:
                                        this.setState({
                                            shouldShowAlert: true,
                                            alertMessage: 'The email you entered did not match any of our records'
                                        });
                                        setTimeout(() => {
                                            // condition to guard against setting state when component is unmounted:
                                            if (this._isMounted) {
                                                this.setState({shouldShowAlert: false});
                                            }
                                        }, 5500);
                                    });
                            }
                        }
                    >
                        <Form className="mt-4">
                            <div>
                                <div className="input-with-icons-container">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <Field className="input" type="text" name="email" placeholder="Email" />
                                </div>
                                <ErrorMessage name="email" component={ErrorLabel} />
                            </div>

                            <div className="mt-4 d-flex flex-no-wrap align-items-center justify-content-between">
                                <Link to="/login" className="link-underline">Go Back</Link>
                                <button className={css.Login__BtnSubmit} type="submit">Reset Password</button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            </div>
        );
    }
};

export default PasswordRecover;
